import { useContext } from 'react';
import { InfoContext } from 'contexts/info_context';

const useInfo = () => {
    return useContext(InfoContext);
};

export default useInfo;
